/* unplugin-vue-components disabled */import { render } from "./cba.vue?vue&type=template&id=bf4576ce&scoped=true"
import script from "./cba.vue?vue&type=script&lang=js"
export * from "./cba.vue?vue&type=script&lang=js"

import "./cba.vue?vue&type=style&index=0&id=bf4576ce&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf4576ce"]])

export default __exports__